import { Actions } from '../actions/Actions';

const ratingReducer = (state: any = {}, action: any) => {
    switch (action.type) {
        case Actions.SET_RATING_CONFIG_DATA:            
            return {
            ...state,
            ratingConfig: action.payload
            
            }       
        case Actions.GET_RATING_CONFIG_DATA:     
            return {
                ...state,
                ratingConfig: state.ratingConfig,            
            };
        case Actions.GET_USER_RATING_DATA:
            
            return {
            ...state,
            user_Rating: state.user_Rating
            
            }       
        case Actions.SET_USER_RATING_DATA:
              
            return {
                ...state,
                user_Rating: action.payload,            
            };
        case Actions.SHOW_RATING_IN_CENTER:
           
            return {
                ...state,
                showInCenter: action.payload.showInCenter                
            }; 
        case Actions.SAVE_MAAS_CREATION_DATA:
            return {
                ...state,
                maaSCreationData: action.payload
                
            };
        case Actions.SAVE_GPS_CREATION_DATA:
            return {
                ...state,
                gpsCreationData: action.payload
                
            };
        default:
            return {...state};
    }
}

export default ratingReducer;
